import Hashids from 'hashids'

export const HASHIDS = new Hashids('baspo-safety-game', 8, 'abcdefghijklmnopqrstuvwxyz1234567890')
